<template>
  <div>
    <div class="row align-items-center">
      <div class="col-md">
        <div class="form-group">
          <input type="text" class="form-control form-control-md" placeholder="Suche ..." v-model="s">
        </div>
      </div>
      <div class="col-md-auto">
        <div class="form-group">
          Zeige {{ orders.length }} von {{ total }}
        </div>
      </div>
    </div>
    <table class="table">
      <thead v-if="orders.length > 0">
        <tr>
          <th v-for="(col, i) of head" :key="i">
            <a href="#" @click="sortBy($event, i)">{{ col }}</a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(order, i) of orders" :key="i">
          <td v-for="(col, j) of order" :key="j">{{ col }}</td>
        </tr>
      </tbody>
    </table>  
  </div>
</template>

<script>

export default {
  name: 'UITable',
  props: ['data'],
  data: function () {
      return {
        s: '',
        orderBy: -1,
        order: 'ASC',
      }
    },
    computed: {
      total: function() {
        return Math.max(this.data.length - 1, 0);
      },
      orders: function() {
        return this.data.filter((order, index) => {
          let match = false
          const words = this.s.split(' ')
          for (var i = 0; i < words.length; i++) {
            const word = words[i];
            match = JSON.stringify(order).toLowerCase().indexOf(word.toLowerCase()) > -1
            if (!match) return false
          }
          return index > 0 && match
        }).sort((a, b) => {
          if (this.orderBy > -1) {
            return a[this.orderBy].localeCompare(b[this.orderBy], 'de-DE') * (this.order == 'ASC' ? 1 : -1)
          }
          return 0
        })
      },
      head: function() {
        return this.data.length > 0 ? this.data[0] : []
      }
    },
    methods: {
      sortBy(event, col) {
        event.preventDefault();

        if (this.orderBy == col) {
          this.order = this.order == 'ASC' ? 'DESC' : 'ASC';
        }
        this.orderBy = col;

        return false
      }
    }
}
</script>